import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: 'nimbus-form-control[nimbusFormControlDoubleSize]',
  standalone: false,
})
export class FormControlDoubleSizeDirective implements AfterViewInit {
  public constructor(private elementReference: ElementRef<HTMLElement>) {}

  public ngAfterViewInit(): void {
    this.elementReference.nativeElement.classList.add('control-size-double-width');
    this.elementReference.nativeElement.classList.remove('control-size-normal');
  }
}
